export default "__VITE_ASSET__C2ln5dmr__"